webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(12)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(10),
  /* template */
  __webpack_require__(18),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_vc_social_bar__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_vc_social_bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_vc_social_bar__);


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__components_vc_social_bar___default.a);

/***/ }),
/* 8 */,
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'VcStyle',
  render: function render(createElement) {
    return createElement('style', this.$slots.default);
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'VcSocialBar',
  components: {
    VcStyle: __WEBPACK_IMPORTED_MODULE_0__style___default.a
  },
  data: function data() {
    return {
      tag: 'vc-social-bar',
      url: window.location.href
    };
  },

  props: {
    popupWidth: {
      type: Number,
      required: false,
      default: 640
    },
    popupHeight: {
      type: Number,
      required: false,
      default: 640
    },
    services: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    title: {
      type: String,
      required: false,
      default: null
    },
    fontSize: {
      type: Number,
      default: 2
    },
    color: {
      type: String,
      required: false,
      default: '#f2f2f2'
    },
    position: {
      type: String,
      required: false,
      default: 'left'
    },
    bgColor: {
      type: String,
      required: false,
      default: 'rgba(0, 0, 0, .75)'
    },
    backdropBlur: {
      type: Number,
      required: false,
      default: 5
    },
    shadow: {
      type: String,
      required: false,
      default: '0 0 .5em rgba(0, 0, 0, 1)'
    },
    zIndex: {
      type: Number,
      required: false,
      default: 1000
    }
  },
  methods: {
    /**
     * Capitalize the first letter of a string
     * @method capitalize
     * @param {number} index
     * @return {string}
     */
    firstLetterCapital: function firstLetterCapital(string) {
      if (typeof string !== 'string') {
        return '';
      }
      return string.charAt(0).toUpperCase() + string.slice(1);
    },

    /**
     * Open url in a popup
     * @method popup
     * @param {string} url
     * @param {string} title
     * @param {number} width
     * @param {number} height
     * @return {object}
     */
    popup: function popup() {
      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.href;
      var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var width = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 640;
      var height = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 480;

      var left = screen.width / 2 - width / 2;
      var top = screen.height / 2 - height / 2;
      return window.open(url, title, 'width=' + width + ', height=' + height + ', top=' + top + ', left=' + left + ', toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no');
    }
  }
});

/***/ }),
/* 11 */,
/* 12 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(9),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 17 */,
/* 18 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.services.length) ? _c('div', {
    class: [_vm.tag, (_vm.tag + "-" + _vm.position)]
  }, [_c('ul', _vm._l((_vm.services), function(service, index) {
    return _c('li', {
      key: index
    }, [_c('a', {
      attrs: {
        "rel": "noopener",
        "href": service.url(_vm.url, _vm.title),
        "title": _vm.firstLetterCapital(service.icon)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.popup(service.url(_vm.url, _vm.title), '', _vm.popupWidth, _vm.popupHeight)
        }
      }
    }, [_c('i', {
      class: ['mdi', ("mdi-" + (service.icon))],
      attrs: {
        "aria-hidden": "true"
      }
    })])])
  }), 0), _vm._v(" "), _c('link', {
    attrs: {
      "rel": "stylesheet",
      "href": "//cdnjs.cloudflare.com/ajax/libs/MaterialDesign-Webfont/2.0.46/css/materialdesignicons.min.css"
    }
  }), _vm._v(" "), _c('vc-style', [_vm._v("\n    .vc-social-bar\n    {\n      z-index: " + _vm._s(_vm.zIndex) + ";\n      background: " + _vm._s(_vm.bgColor) + ";\n      box-shadow: " + _vm._s(_vm.shadow) + ";\n      backdrop-filter: blur(" + _vm._s(_vm.backdropBlur) + "px);\n    }\n\n    .vc-social-bar .mdi {\n      font-size: " + _vm._s(_vm.fontSize) + "em;\n    }\n\n    .vc-social-bar a,\n    .vc-social-bar .mdi {\n      color: " + _vm._s(_vm.color) + ";\n    }\n  ")])], 1) : _vm._e()
},staticRenderFns: []}

/***/ })
],[7]);


// WEBPACK FOOTER //
// docs/js/vc-social-bar.b070adea003c1db577fc.js